import React from 'react';

export default customData =>
  React.useEffect(() => {
    window.enterPageUserback(customData);

    return window.exitPageUserback;
  });
